import * as React from "react";

import { cn } from "@/lib/utils";

function Input({ className, type, ...props }: React.ComponentProps<"input">) {
  return (
    <input
      type={type}
      data-slot="input"
      className={cn(
        "h-11 sm:h-10 w-full min-w-0 rounded-md border px-3 py-2 text-base shadow-xs transition-all outline-none",
        "bg-[#1A1A30] border-[#2A2A45] text-white placeholder:text-[#6A6A8A]",
        "focus:border-[#F37020] focus:ring-[3px] focus:ring-[#F37020]/30",
        "file:text-white file:inline-flex file:h-7 file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "disabled:pointer-events-none disabled:cursor-not-allowed disabled:opacity-50",
        "selection:bg-[#F37020] selection:text-white",
        className,
      )}
      {...props}
    />
  );
}

export { Input };
